var _style, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHouseMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "44px",
    height: "54px",
    viewBox: "0 0 44 54",
    style: {
      enableBackground: "new 0 0 44 54"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#D65194;}\n\t.st2{fill:none;stroke:#FFFFFF;stroke-linecap:round;stroke-linejoin:round;}\n\t.st3{fill:#FFFFFF;stroke:#FFFFFF;stroke-linecap:round;stroke-linejoin:round;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_351_00000134239016980073371890000008250868004988342418_",
    className: "st0",
    d: "M35.9,1.5H8.1c-3.6,0-6.6,2.9-6.6,6.6v27.7 c0,3.6,3,6.6,6.6,6.6H18l4.1,8.3l4.1-8.3h9.6c3.6,0,6.6-2.9,6.6-6.6V8.1C42.5,4.5,39.5,1.5,35.9,1.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M22.1,54L17,43.9H8.1c-4.5,0-8.1-3.6-8.1-8.1V8.1C0,3.6,3.6,0,8.1,0h27.8C40.4,0,44,3.6,44,8.1v27.7 c0,4.5-3.6,8.1-8.1,8.1h-8.7L22.1,54z M8.1,3C5.3,3,3,5.3,3,8.1v27.7c0,2.8,2.3,5.1,5.1,5.1h10.8l3.2,6.4l3.2-6.4h10.6 c2.8,0,5.1-2.3,5.1-5.1V8.1C41,5.3,38.7,3,35.9,3H8.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M35.4,20.6l-4-4v-6.6c0-0.3-0.2-0.5-0.5-0.5h-3.1c-0.3,0-0.5,0.2-0.5,0.5v2.4l-4.9-4.9c-0.2-0.2-0.5-0.2-0.7,0 l-13.1,13c-0.2,0.2-0.2,0.5,0,0.7l2.1,2.1c0.2,0.2,0.5,0.2,0.7,0l0.2-0.2V33c0,0.9,0.7,1.5,1.6,1.5h17.8c0,0,0,0,0,0 c0.9,0,1.5-0.7,1.6-1.5v-9.7l0.2,0.2c0.2,0.2,0.5,0.2,0.7,0l2.1-2.1C35.6,21.2,35.6,20.8,35.4,20.6z M25.7,33.5h-7.3v-9.9h7.3V33.5z "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_353",
    className: "st2",
    d: "M10.6,23.9l11.3-11.3l11.6,11.6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_354",
    className: "st3",
    d: "M18.2,34.7V23.6h7.4v11.6C25.7,35.2,18.2,34.6,18.2,34.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseMarker);
export default __webpack_public_path__ + "static/media/house-marker.42b291bab0a4b0d86d3c3e95dae3902b.svg";
export { ForwardRef as ReactComponent };